var Acr = window.Acr || {};

Acr.LanguageSelector = (function (window, $) {
  

  var currentLanguage = 'EN';
  var currentLanguageCode = 'EN';
  var languages = {
    en: {
      code: 'EN',
      name: 'English',
      langCode: 'EN',
      subDomain: 'www',
    },
    es: {
      code: 'ES',
      name: 'Espa&ntilde;ol',
      langCode: 'ES',
      subDomain: 'spanish',
    },
    zh: {
      code: '&#x4E2D;&#x6587;',
      name: '&#x4E2D;&#x6587;',
      langCode: 'ZH',
      subDomain: 'chinese',
    },
  };

  // Updates the current label to be shown in the Global Nav drop down that sits
  // next to the globe SVG, according to the current URL.
  // Default language will be English: "EN"
  var updateGlobalNavLanguageLabel = function () {
    var $globalNavLanguageLabel = $('.current-language');
    var regex;

    if ($globalNavLanguageLabel.length > 0) {
      $.each(languages, function (idx, val) {
        regex = new RegExp(val.subDomain + '.acura.com');

        if (window.location.href.match(regex)) {
          currentLanguage = val.code;
          currentLanguageCode = val.currentLanguageCode;
        }
      });

      $globalNavLanguageLabel.html(currentLanguage);
    }
  };

  var updateSelectedLanguage = function () {
    var $languageItems = $('.acr-nav-lang-chooser__list-item');

    $.each($languageItems, function (i) {
      if ($($languageItems[i]).data('language-code') === currentLanguageCode) {
        $($languageItems[i]).find('a').addClass('acr-nav-lang-chooser__item-link--selected');
      }
    });
  };

  var init = function () {
    updateGlobalNavLanguageLabel();
    updateSelectedLanguage();
  };

  return {
    init: init,
  };
}(window, $));
